import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FC } from "react";
import { useDispatch } from "react-redux";
import {
  addItemToCart,
  decrementCartItemCount,
  ICartItem,
} from "../../stateManagement/reducers/cartReducer";
import AnimateButton from "../@extended/AnimateButton";

interface IProps {
  cartItem: ICartItem;
}

const SelectionButton: FC<IProps> = ({ cartItem }) => {
  const dispatch = useDispatch<any>();

  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        height: "100%",
      }}
    >
      <AnimateButton>
        <Button
          variant="contained"
          size="small"
          sx={{
            color: "white !important",
            fontWeight: "700",
            background: "linear-gradient(to top, #8b0000, #ff5e57)",
            border: "none !important",
            p: { xs: "1rem", md: ".5rem !important" },
            minWidth: idGreaterThanMd ? undefined : "fit-content",
          }}
          onClick={() => {
            dispatch(
              decrementCartItemCount({
                rentalItemId: cartItem.rentalItem._id,
                count: 1,
              }),
            );
          }}
        >
          -
        </Button>
      </AnimateButton>
      <Typography sx={{ px: ".5rem", color: "black !important" }}>
        <b>{cartItem.count}</b>
      </Typography>
      <AnimateButton>
        <Button
          variant="contained"
          size="small"
          color="info"
          sx={{
            color: "white !important",
            fontWeight: "700",
            background: "linear-gradient(to top,#2b6e3f, #4caf50)",
            border: "none !important",
            p: { xs: "1rem", md: ".5rem !important" },
            minWidth: idGreaterThanMd ? undefined : "fit-content",
          }}
          onClick={() => {
            dispatch(
              addItemToCart({ rentalItem: cartItem.rentalItem, count: 1 }),
            );
          }}
        >
          +
        </Button>
      </AnimateButton>
    </Stack>
  );
};

export default SelectionButton;
